import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './method-of-travel-to-work.reducer';

export const MethodOfTravelToWorkDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const methodOfTravelToWorkEntity = useAppSelector(state => state.methodOfTravelToWork.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="methodOfTravelToWorkDetailsHeading">
          <Translate contentKey="apiLocationApp.methodOfTravelToWork.detail.title">MethodOfTravelToWork</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{methodOfTravelToWorkEntity.id}</dd>
          <dt>
            <span id="geographicLevel">
              <Translate contentKey="apiLocationApp.methodOfTravelToWork.geographicLevel">Geographic Level</Translate>
            </span>
          </dt>
          <dd>{methodOfTravelToWorkEntity.geographicLevel}</dd>
          <dt>
            <span id="date">
              <Translate contentKey="apiLocationApp.methodOfTravelToWork.date">Date</Translate>
            </span>
          </dt>
          <dd>{methodOfTravelToWorkEntity.date}</dd>
          <dt>
            <span id="geography">
              <Translate contentKey="apiLocationApp.methodOfTravelToWork.geography">Geography</Translate>
            </span>
          </dt>
          <dd>{methodOfTravelToWorkEntity.geography}</dd>
          <dt>
            <span id="geographyCode">
              <Translate contentKey="apiLocationApp.methodOfTravelToWork.geographyCode">Geography Code</Translate>
            </span>
          </dt>
          <dd>{methodOfTravelToWorkEntity.geographyCode}</dd>
          <dt>
            <span id="totalAllUsualResidents">
              <Translate contentKey="apiLocationApp.methodOfTravelToWork.totalAllUsualResidents">Total All Usual Residents</Translate>
            </span>
          </dt>
          <dd>{methodOfTravelToWorkEntity.totalAllUsualResidents}</dd>
          <dt>
            <span id="workMainlyAtHome">
              <Translate contentKey="apiLocationApp.methodOfTravelToWork.workMainlyAtHome">Work Mainly At Home</Translate>
            </span>
          </dt>
          <dd>{methodOfTravelToWorkEntity.workMainlyAtHome}</dd>
          <dt>
            <span id="underground">
              <Translate contentKey="apiLocationApp.methodOfTravelToWork.underground">Underground</Translate>
            </span>
          </dt>
          <dd>{methodOfTravelToWorkEntity.underground}</dd>
          <dt>
            <span id="train">
              <Translate contentKey="apiLocationApp.methodOfTravelToWork.train">Train</Translate>
            </span>
          </dt>
          <dd>{methodOfTravelToWorkEntity.train}</dd>
          <dt>
            <span id="bus">
              <Translate contentKey="apiLocationApp.methodOfTravelToWork.bus">Bus</Translate>
            </span>
          </dt>
          <dd>{methodOfTravelToWorkEntity.bus}</dd>
          <dt>
            <span id="taxi">
              <Translate contentKey="apiLocationApp.methodOfTravelToWork.taxi">Taxi</Translate>
            </span>
          </dt>
          <dd>{methodOfTravelToWorkEntity.taxi}</dd>
          <dt>
            <span id="motorcycle">
              <Translate contentKey="apiLocationApp.methodOfTravelToWork.motorcycle">Motorcycle</Translate>
            </span>
          </dt>
          <dd>{methodOfTravelToWorkEntity.motorcycle}</dd>
          <dt>
            <span id="drivingCarVan">
              <Translate contentKey="apiLocationApp.methodOfTravelToWork.drivingCarVan">Driving Car Van</Translate>
            </span>
          </dt>
          <dd>{methodOfTravelToWorkEntity.drivingCarVan}</dd>
          <dt>
            <span id="passengerCarVan">
              <Translate contentKey="apiLocationApp.methodOfTravelToWork.passengerCarVan">Passenger Car Van</Translate>
            </span>
          </dt>
          <dd>{methodOfTravelToWorkEntity.passengerCarVan}</dd>
          <dt>
            <span id="bicycle">
              <Translate contentKey="apiLocationApp.methodOfTravelToWork.bicycle">Bicycle</Translate>
            </span>
          </dt>
          <dd>{methodOfTravelToWorkEntity.bicycle}</dd>
          <dt>
            <span id="onFoot">
              <Translate contentKey="apiLocationApp.methodOfTravelToWork.onFoot">On Foot</Translate>
            </span>
          </dt>
          <dd>{methodOfTravelToWorkEntity.onFoot}</dd>
          <dt>
            <span id="otherMethod">
              <Translate contentKey="apiLocationApp.methodOfTravelToWork.otherMethod">Other Method</Translate>
            </span>
          </dt>
          <dd>{methodOfTravelToWorkEntity.otherMethod}</dd>
        </dl>
        <Button tag={Link} to="/method-of-travel-to-work" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/method-of-travel-to-work/${methodOfTravelToWorkEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MethodOfTravelToWorkDetail;
